import ApiService, { callCustomMethodAsync } from "../service/ApiService";

let moduleApi = {};
let moduleName = "employee_request";

moduleApi.create = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "create",
    value: dataForm,
    message: {
      success: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.update = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.list = async (dataFilter, loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: loading == undefined ? false : loading
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.delete = async (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: { id: id }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: { id: id }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.AppovalRequest = async (data) => {
  let api = {
    module: moduleName,
    type: "AppovalRequest",
    body: data,
    message: {
      success: "hidden", //string | null | comment
      error: "hidden" //string | null | comment
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.UnAppovalRequest = async (data) => {
  let api = {
    module: moduleName,
    type: "UnAppovalRequest",
    body: data,
    message: {
      success: "hidden", //string | null | comment
      error: "hidden" //string | null | comment
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.GetListEmloyeeRequestDayoff = async (data) => {
  let api = {
    module: moduleName,
    type: "GetListEmloyeeRequestDayoff",
    body: data,
    message: {
      success: "hidden", //string | null | comment
      error: "hidden" //string | null | comment
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};


moduleApi.CalcNumberOfDayOffOfEmployee = async (data) => {
  let api = {
    module: moduleName,
    type: "CalcNumberOfDayOffOfEmployee",
    body: data,
    message: {
      success: "hidden", //string | null | comment
      error: "hidden" //string | null | comment
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.CheckAnnualLeaveAvailability = async (data) => {
  let api = {
    module: moduleName,
    type: "CheckAnnualLeaveAvailability",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  return await callCustomMethodAsync(api);
};

moduleApi.GetAnnualLeaveDeductionHistory = async (data) => {
  let api = {
    module: moduleName,
    type: "GetAnnualLeaveDeductionHistory",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  return await callCustomMethodAsync(api);
};

moduleApi.getListEmployeeRequestDetail = async (data, loading) => {
  let api = {
    module: moduleName,
    type: "views",
    viewAction: "getListEmployeeRequestDetail",
    value: data,
    dontLoading: (loading == undefined ? false : loading ),
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.getListEmployeeRequest = async (data,loading) => {
  let api = {
    module: moduleName,
    type: "views",
    viewAction: "getListEmployeeRequest",
    value: data,
    dontLoading: (loading == undefined ? false : loading ),
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.getListEmployeeRequestAll = async (data,loading) => {
  let api = {
    module: moduleName,
    type: "views",
    viewAction: "getListEmployeeRequestAll",
    value: data,
    dontLoading: (loading == undefined ? false : loading ),
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.GetCountRequestDayoffs = async (data) => {
  let api = {
    module: moduleName,
    type: "GetCountRequestDayoffs",
    body: data,
    message: {
      success: "hidden", //string | null | comment
      error: "hidden" //string | null | comment
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.GetEmployeeRequestByStatus = async (data) => {
  let api = {
    module: moduleName,
    type: "GetEmployeeRequestByStatus",
    body: data,
    message: {
      success: "hidden", //string | null | comment
      error: "hidden" //string | null | comment
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.CancelRequest = async (data) => {
  let api = {
    module: moduleName,
    type: "CancelRequest",
    body: data,
    message: {
      success: "hidden", //string | null | comment
      error: "hidden" //string | null | comment
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

export default moduleApi;
